export default "__VITE_ASSET__d19a9a23__"